// import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
// import { setCookie, getCookie } from '../../utils/cookie'
// import { Toast, Dialog } from 'vant'
//
// Vue.use(Toast)
// Vue.use(Dialog)
// Vue.use(Dialog)

// export const url = 'http://118.178.24.108/skzb'
// export const url = 'http://172.21.20.254:8080/skzb'

export const isDev = process.env.NODE_ENV === 'development';
// export const isDev = false;
export const url = isDev ? "http://172.21.20.252:9090/wndjsjd-api" : "http://58.215.195.190:9090/wndjsjd-api/";
export const file_path = isDev ? "http://58.215.195.190:9090/" : "http://58.215.195.190:9090/";
let Vue = null
// const tokenString = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXNzd29yZCI6Imp4amQiLCJuYW1lIjoi5rGf5rqq6KGX6YGTIiwidXNlck5hbWUiOiJqeGpkIiwiZXhwIjoxNjM5MTI3NjU5LCJ1c2VySWQiOiIzOTAifQ.qfceJPGRLBFPLkseu1dCQ-QQQKnHce4jW7aYnFUsVJc'
export function setVue(data) {
  Vue = data
}

let http = axios.create({
  transformRequest: [data => Qs.stringify(data)],
  baseURL: url,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  timeout: '50000'
})

/**
 *登陆
 *单独接口不可通用
 * @export
 * @param {*} dataObj 对象格式参数
 * @param {*} url url地址
 * @returns
 */
export function login(url, dataObj) {
  return http
    .post(url, dataObj)
    .then(res => {
      // 本地存储
      sessionStorage.setItem('token', res.data.data.token)
      sessionStorage.setItem('openid', res.data.data.openid)
      sessionStorage.setItem('filePath', res.data.data.filePath)
      sessionStorage.setItem('user', JSON.stringify(res.data.data))
      return new Promise((resolve, reject) => {
        // Toast.clear()
        resolve(res.data)
      })
    })
    // .catch(erro => {
    //   // Toast.clear()
    //   // Toast('登录超时，请检查网络设置')
    //   Vue.$message({
    //     message: "网络连接超时，请检查网络",
    //     type: "error"
    //   });
    // })
}

/**
 *get请求通用
 * @param {*} url
 * @param {*} dataObj
 */
export function axiosGet(url, dataObj) {
  // Toast.loading({
  //   mask: true,
  //   message: '加载中...',
  //   type: 'loading',
  //   forbidClick: true,
  //   loadingType: 'circular',
  //   duration: '50000'
  // })
  return http
    .get(url, {
      headers: {
        token: sessionStorage.getItem('token'),
        // token: tokenString,
        openid: sessionStorage.getItem('openid')
      },
      params: dataObj
    })
    .then(res => {
      return new Promise((resolve, reject) => {
        res.data.code === 403
          // ? Dialog.alert({
          //     message: '用户登录过期，请重新登陆'
          //   }).then(() => {
          //     // Toast.clear()
          //     vue.$router.push({ name: 'login' })
          //   })
          // : resolve(res.data, null, Toast.clear())
          ? Vue.$alert("用户已过期，请重新登陆", "标题名称", {
            confirmButtonText: "确定",
            callback: action => {
              Vue.$router.push({name: "login"});
              // window.location.href = res.url
            }
          })
          : resolve(res.data, null)
      })
    })
    .catch(erro => {
      // Toast.clear()
      // Toast('登录超时，请检查网络设置')
      Vue.$message({
        message: "网络连接超时，请检查网络",
        type: "error"
      });
    })
}

/**
 *添加用户列表
 *post请求通用
 * @export
 * @param {*} url
 * @param {*} dataObj
 */
export function axiosPost(url, dataObj, params) {
  return http
    .post(url, dataObj, {
      headers: {
        token: sessionStorage.getItem('token'),
        // token: tokenString,
        openid: sessionStorage.getItem('openid')
      },
      params: params
    })
    .then(res => {
      return new Promise((resolve, reject) => {
        res.data.code === 403
          ? Vue.$alert("用户已过期，请重新登陆", "标题名称", {
            confirmButtonText: "确定",
            callback: action => {
              Vue.$router.push({name: "login"});
              // window.location.href = res.url
            }
          })
          : resolve(res.data, null)
      })
    })
    .catch(erro => {
      // Toast.clear()
      // Toast('登录超时，请检查网络设置')
      Vue.$message({
        message: "网络连接超时，请检查网络",
        type: "error"
      });
    })
}
export function axiosPut(url, dataObj) {
  return http
    .put(url, dataObj, {
      headers: {
        token: sessionStorage.getItem('token'),
        openid: sessionStorage.getItem('openid')
      }
    })
    .then(res => {
      return new Promise((resolve, reject) => {
        res.data.code === 403
          ? Vue.$alert('用户已过期，请重新登陆', '标题名称', {
            confirmButtonText: '确定',
            callback: action => {
              Vue.$router.push({ name: 'login' })
            }
          })
          : resolve(res.data, null)
      })
    })
    .catch(erro => {
      Vue.$message({
        message: '网络连接超时，请检查网络',
        type: 'error'
      })
    })
}
// 新窗口打开页面
export function windowOpen(query) {
  window.open(url + query)
}



// WEBPACK FOOTER //
// ./src/assets/js/http.js